import {useCallback} from 'react';

import {useLinkNavigation} from '../../components/common/navigation/useLinkNavigation';
import {SettingsResourcePagesEnum} from '../../models/url/settingsUrlModel';
import {makeSettingsUrlFromPathId, SettingsPathId} from '../menu/settingsHelpers';

interface CircleNavigateParams {
  circleId?: number;
}

export function useCircleNavigateToLink() {
  const {navigateToLink} = useLinkNavigation();

  const navigateTo = useCallback(
    (resourcePage: SettingsResourcePagesEnum, params: CircleNavigateParams = {}) => {
      const pathId = maybeGetPathId(resourcePage);

      if (!pathId) {
        return;
      }

      const url = makeSettingsUrlFromPathId(pathId, {namespace: 'global', circle: params.circleId});
      navigateToLink(url);
    },
    [navigateToLink],
  );

  return navigateTo;
}

function maybeGetPathId(resourcePage: SettingsResourcePagesEnum): SettingsPathId | undefined {
  switch (resourcePage) {
    case SettingsResourcePagesEnum.OVERVIEW:
      return 'settings.circles';

    case SettingsResourcePagesEnum.EDIT:
      return 'settings.circles.edit';

    case SettingsResourcePagesEnum.NEW:
      return 'settings.circles.new';

    default:
      return undefined;
  }
}
